<template>
  <div class="c-people-view">
    <div class="c-people-view_container c-view-container">
      <div class="c-view-container__inner">
        <div class="c-people-view_content-col c-view-content-col">
          <h1 class="c-people-view__heading">Your Home</h1>

          <h2 class="c-people-heading">
            {{ PeopleQuestion.PeopleQuestionViewQuestion }}
          </h2>
          <p
            class="c-people-view__question-note"
            v-if="PeopleQuestion.PeopleQuestionViewNoteText"
          >
            {{ PeopleQuestion.PeopleQuestionViewNoteText }}
          </p>

          <ul class="c-people-fields">
            <li class="c-people-field">
              <input
                type="radio"
                id="OneTwo"
                value="1-2 PEOPLE"
                v-model="peopleQuestion"
              />
              <label for="OneTwo"
                ><p>1-2 people</p>
                <img src="_resources/app/client/assets/images/2person.svg" alt="person icon"
              /></label>
            </li>

            <li class="c-people-field">
              <input
                type="radio"
                id="Three"
                value="3 PEOPLE"
                v-model="peopleQuestion"
              />
              <label for="Three"
                ><p>3 people</p>
                <img src="_resources/app/client/assets/images/3person.svg" alt="person icon"
              /></label>
            </li>

            <li class="c-people-field">
              <input
                type="radio"
                id="Four"
                value="4 PEOPLE"
                v-model="peopleQuestion"
              />
              <label for="Four"
                ><p>4 people</p>
                <img src="_resources/app/client/assets/images/4person.svg" alt="person icon"
              /></label>
            </li>

            <li class="c-people-field">
              <input
                type="radio"
                id="FivePlus"
                value="5+ PEOPLE"
                v-model="peopleQuestion"
              />
              <label for="FivePlus"
                ><p>5+ PEOPLE</p>
                <img src="_resources/app/client/assets/images/5person.svg" alt="person icon"
              /></label>
            </li>
          </ul>
        </div>

        <div class="c-people-view_animation-col c-view-animation-col">
          <div class="c-question-view_animation-wrapper">
            <div class="c-question-view_animation-circle"></div>
            <lottie-vue-player
              :src="animationsURL + `house_animation.json`"
              :player-controls="false"
              :loop="true"
              :autoplay="true"
            >
            </lottie-vue-player>
          </div>
        </div>
      </div>
    </div>

    <div class="c-view-controls__wrapper">
      <div class="c-view-controls">
        <div class="c-view-controls__inner">
          <button
            class="u-calc-button u-calc-button--prev"
            @click="backToStart"
          >
            <span></span>
            <p>Previous</p>
          </button>
          <button class="u-calc-button" @click="next" v-if="canNavigateNext">
            <p>Next</p>
            <span></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";

export default {
  data: () => ({}),
  created() {},
  components: {},
  mounted() {},
  methods: {
    next() {
      this.$store.dispatch("updateCurrentStepByDirection", "next");
    },
    backToStart() {
      this.currentView = "LetsGetStartedView";
    },
  },
  computed: {
    canNavigateNext() {
      return this.peopleQuestion !== "";
    },
    ...mapFields([
      "viewContent.PeopleQuestion",
      "submission.peopleQuestion",
      "config.currentStep",
      "config.baseUrl",
      "config.currentView",
    ]),
    /**
     * Returns animation url
     *
     * @return string
     * **/
    animationsURL() {
      return this.baseUrl + "/app/animations/";
    },
  },
};
</script>
<style lang="scss">
.c-people-view {
}

.c-people-view__heading {
  font-family: "Nunito" !important;
  font-weight: 800 !important;
  font-size: 48px !important;
  line-height: 54px !important;
  margin: 0 !important;
  color: #ffffff;
  margin-bottom: 24px;

  @media (max-width: 755px) {
    font-size: 32px !important;
    line-height: 36px !important;
    margin-bottom: 12px;
  }
}

.c-people-heading {
  @media (max-width: 755px) {
    margin-top: 20px;
  }
}

.c-people-view__question {
  margin-bottom: 10px !important;
}

.c-people-view__question-note {
  margin-bottom: 20px !important;
}
.c-people-view_container {
  // display: flex;
  // flex-direction: row;
}

.c-people-view_animation-wrapper {
  max-width: 550px; //todo sacle this up with screen size
  margin: 0 0 0 auto;
}

.c-people-field {
  display: block;
  input {
    visibility: hidden;
    position: fixed;
    left: -999px;
    top: -999px;
    &:checked + label {
      background: #04b776;
    }
  }
  label {
    display: inline-flex;
    cursor: pointer;
    background: #ffffff;
    border: 2px solid #000000;
    border-radius: 50px;
    color: #000000;
    margin-bottom: 8px !important;
    padding: 16px 37px;
    text-decoration: none;
    text-transform: uppercase;

    @media (max-width: 755px) {
      padding: 14px 22px;
    }

    p {
      flex: 1;
      font-family: "Nunito";
      font-weight: 800;
      font-size: 14px;
      line-height: 19px;
      margin: 0;
      white-space: nowrap;
    }
    img {
      flex: 1;
      margin-left: 26px;

      @media (max-width: 755px) {
        margin-left: 10px;
      }

    }
  }
}
</style>
